import { SchoolAdminDashboard } from "./page"

export default SchoolAdminDashboard
